import { makeStyles } from "@mui/styles";
import {
  primary_color_2,
  primary_gradient,
  text_color_dark,
} from "../../themes/colors";


const useStyles = makeStyles({
  item_outer: {
    height: "60px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "10px 0px",
    border: `3px solid ${primary_color_2}66 `,
    borderRadius: "10px !important",
    transition: "0.5s",
    cursor: "pointer",
    position: "relative",    
    boxShadow: 'none !important',
    "&:hover": {
      border: `3px solid ${primary_color_2}`,
      boxShadow: `1px 2px 9px ${primary_color_2}22 !important`,
    },
    textAlign:'center'
  },
  name: {
    color: text_color_dark,
    fontWeight: "bold",
    width: "100%",
    borderRadius: "5px",
    fontSize: "15px",
    textAlign:'center',
    transition:'0.2s',
    '&:hover':{
      fontSize: "20px",
      padding: "2px"
    },
    padding: "6px"
  },
  tableStatus: {
    color: text_color_dark,
    fontWeight: "bold",
    backgroundColor: "white",
    width: "30px",
    height: "30px",
    padding: "5px",
    borderRadius: "50%",
    fontSize: "10px",
    display: "block",
    position: "fixed",
  },
  price: {
    color: "white",
    fontWeight: "bold",
    backgroundImage: primary_gradient,
    width: "fit-content",
    padding: "2px 10px",
    borderRadius: "5px",
    fontSize: "12px",
  },
  old_price: {
    fontSize: "10px",
    color: "white",
    textDecoration: "line-through",
  },
  edit_row: { position: "absolute", bottom: 5, right: 5, display: "flex" },
  edit_button: {
    backgroundImage: primary_gradient,
    color: "white",
    padding: "5px",
  },
  inactive_seal: {
    backgroundImage: "url(/images/inactive.png)",
    backgroundColor: "#ffffffb0",
    height: "100%",
    width: "100%",
    position: "absolute",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    top: 0,
    left: 0,
  },
});



export default useStyles;
